import { useState } from "react";
import FormGenerator from "./FormGenerator";
import academicLevelsData from "../../../data/academicLevelsData";
import workStatusData from "../../../data/workStatusData";

interface Props{
    onChange: (val:any) => void;
}
const WorkStatusForm:React.FC<Props> = ({onChange}) => {
    const [text, setText] = useState('');
    const [workStatus, setWorkStatus] = useState<number | undefined>(undefined);
    const [showGrad, setShowGrad] = useState(false);

    // Function to handle work status change
    const handleWorkStatusChange = (id: number) => {
        setWorkStatus(id);
        onChange({workingStatusId:id});
    };

    const handleSalaryChange = (val:number) => {
        onChange({salary:val});
    }

    return (
        <div className="h-full w-full flex flex-col justify-center">
            <FormGenerator
                title="Work Status"
                label="What is your current work status?"
                type="select"
                onChange={(val: number) => handleWorkStatusChange(val)}
                options={workStatusData.map((status) => ({
                    value: status.id,
                    label: status.name,
                }))}
            />
            {
                workStatus && workStatus < 6 && (
                    <FormGenerator
                        label={'What is your monthly gross?'}
                        type="number"
                        onChange={handleSalaryChange}
                    />
                )
            }
        </div>
    );
};

export default WorkStatusForm;
